import React, { useState, useEffect, useRef, useCallback } from "react";
import { Button, Icons } from '@curves/ui-base';
import { useHistory, useParams, useLocation } from "react-router-dom";
import { PageLayout } from "@Local/Components/Layout";
import { CyclePurchaseDetailOrder, CyclePurchaseDetailTabs } from "@Local/CyclePurchase/Detail";
import useCyclePurchaseOverviewApi from "@Apis/useCyclePurchaseOverviewApi";
import { CYCLE_PURCHASE_OVERVIEW_ROUTER, CYCLE_PURCHASE_CANCEL_OVERVIEW_ROUTER } from "@Router/routerPath";
import { isNumber } from "@Util/utils";
import CyclePurchaseCancelDialogBox from "./Detail/Dialog/CyclePurchaseCancelDialogBox";

import { v4 as uuid } from "uuid";
const CyclePurchaseDetailPage = () => {
	const history = useHistory();
	const location = useLocation();
	const { cycleOrderID } = useParams();
	const { getCyclePurchaseDetailApi } = useCyclePurchaseOverviewApi();
	const [detailData, setDetailData] = useState(null);
	const cyclePurchaseCancelDialogRef = useRef(null);
	const isMountedRef = useRef(true);
	const handleBackToOverview = () => {
		const searchParams = new URLSearchParams(location.search || "");
		const fromCancelOverview = searchParams.get("from") === "cancel-overview";
		// 根據來源決定返回的頁面
		if (fromCancelOverview) {
			// 返回退訂總覽頁
			history.push({
				pathname: CYCLE_PURCHASE_CANCEL_OVERVIEW_ROUTER,
			});
		} else {
			// 返回循環訂單總覽頁，並維持搜尋條件
			const overviewSearch = searchParams.toString();
			history.push({
				pathname: CYCLE_PURCHASE_OVERVIEW_ROUTER,
				search: `${overviewSearch}&mode=load`,
			});
		}
	};
	// 開啟循環訂單退訂彈窗
	const openCyclePurchaseCancelDialog = () => {
		cyclePurchaseCancelDialogRef.current.openCyclePurchaseCancelDialog({ cycleOrderID }, refreshDetailData);
	};
	// 取得明細資料（掛載後才更新 state，避免卸載後 setState）
	const doCyclePurchaseDetailApi = async cID => {
		const response = await getCyclePurchaseDetailApi(cID);
		if (isMountedRef.current && response && response.success !== false) {
			setDetailData(response.result || response);
		}
	};
	const refreshDetailData = useCallback(
		() => {
			doCyclePurchaseDetailApi(cycleOrderID);
		},
		// eslint-disable-next-line
		[cycleOrderID]
	);
	// 進入明細頁時捲動到最上方
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	// 掛載／卸載旗標，供 React 18 重掛載時重設
	useEffect(() => {
		isMountedRef.current = true;
		return () => {
			isMountedRef.current = false;
		};
	}, []);
	// 獲取明細資料
	useEffect(
		() => {
			if (isNumber(cycleOrderID) && cycleOrderID !== 0) {
				doCyclePurchaseDetailApi(cycleOrderID);
			}
		},
		// eslint-disable-next-line
		[cycleOrderID]
	);
	return (
		<PageLayout>
			<PageLayout.Header title="循環訂單主單明細">
				<Button color="primary" startIcon={<Icons.Reply />} onClick={handleBackToOverview} />
				<Button variant="contained" color="secondary" className="ml-auto" onClick={openCyclePurchaseCancelDialog}>
					退訂主單
				</Button>
			</PageLayout.Header>
			<CyclePurchaseDetailOrder detailData={detailData} />
			<CyclePurchaseDetailTabs key={uuid()} detailData={detailData} />
			<CyclePurchaseCancelDialogBox ref={cyclePurchaseCancelDialogRef} />
		</PageLayout>
	);
};
export default CyclePurchaseDetailPage;
